module.exports = __webpack_public_path__ + "img/de.8e36924f.svg";